import { render, staticRenderFns } from "./HornorBuyGuideShiftUp.vue?vue&type=template&id=1b6515d4&scoped=true&"
import script from "./HornorBuyGuideShiftUp.vue?vue&type=script&lang=js&"
export * from "./HornorBuyGuideShiftUp.vue?vue&type=script&lang=js&"
import style0 from "./HornorBuyGuideShiftUp.vue?vue&type=style&index=0&id=1b6515d4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6515d4",
  null
  
)

export default component.exports